var _defs, _rect, _ellipse, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsIllustrator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.72 160.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#390000;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#ff9a00;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 160.72,
    height: 160.91
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 120.58,
    cy: 46.51,
    rx: 9.94,
    ry: 9.95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.87,
    y: 62.63,
    width: 17.15,
    height: 61.72,
    rx: 7.96,
    ry: 7.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.11,42.64h-20.54c.26,4.05-.88,7.57-.88,7.57l-24.97,72.07c-.29.84.33,1.72,1.22,1.72h1.06l13.21.04c.57,0,1.07-.36,1.24-.9l5.82-18.38,28.67.09,6.16,18.31c.18.53.67.88,1.23.88h15.68c.89,0,1.52-.88,1.22-1.73l-27.89-78.81c-.18-.52-.67-.86-1.22-.86ZM54.63,89.09s8.91-27.47,9.62-32.23l10.03,32.23h-19.64Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsIllustrator);
export default __webpack_public_path__ + "static/media/Icons_Illustrator.9d25eb6302a83843baba1288f719aca6.svg";
export { ForwardRef as ReactComponent };